module.exports = __webpack_public_path__ + "static/media/house.b0d140ee.jpg";